import { useRouter, type ErrorComponentProps } from "@tanstack/react-router";
import { NotFoundPage } from "@/components/NotFoundPage";

/** Default `notFoundComponent` for the root route. */
export function RootNotFound() {
  return <NotFoundPage />;
}

/** Default `errorComponent` for the root route. */
export function RootErrorBoundary({ error, reset }: ErrorComponentProps) {
  // eslint-disable-next-line no-console
  console.error(error);
  const router = useRouter();
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="max-w-md text-center">
        <h1 className="text-xl">Something went wrong</h1>
        <p className="mt-2 text-sm text-muted-foreground">Please try again in a moment.</p>
        <div className="mt-6 flex justify-center gap-2">
          <button
            onClick={() => {
              router.invalidate();
              reset();
            }}
            className="rounded-full bg-primary text-primary-foreground px-5 py-2.5 text-sm font-medium"
          >
            Try again
          </button>
          <a
            href="/"
            className="rounded-full border border-border px-5 py-2.5 text-sm font-medium"
          >
            Go home
          </a>
        </div>
      </div>
    </div>
  );
}